import React, {useContext, useState, useEffect} from 'react';
import {Stack, Typography, Button, Box, useMediaQuery} from '@mui/material';
import {AllHealthScore} from './Components/allhealthscore';
import {AnimationLoadingScreenWithProgressBar} from '../../components/loading/loadingScreen';
import {getThemeHexColor} from '../../utils/miscellaneous';
import APIObjectsContext from '../../context/APIObjectsContext';
import MiscContext from '../../context/MiscContext';
import {useNuralogixApi} from '../../api/nuralogix';
import {useAssessmentApi} from '../../api/assessment';
import {useQuestionnaireApi} from '../../api/demographics';
import {CarouselPage} from './Components/carouselpage';
import dayjs from 'dayjs';
import {Swiper, SwiperSlide} from 'swiper/react';
import {useRef} from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// Swiper's Custom CSS
import './styles.css';

// import required modules
import {EffectCoverflow, EffectFade, Navigation, Pagination} from 'swiper/modules';
import DynamicProgressBar from '../../components/progressBars/dynamicProgressBar';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import getHealthFunctions from './helperfunctions';
import {CLIENT_TYPES} from '../../api/clientconfig';

import {getClientConfig, getClientTypeFromOrgId, ORGANIZATION_IDS} from '../../config/clientThemes';
import ResultsDialog from '../DoktorConnect/components/doktorcreditspopup';
import {useClientApi} from '../../api/client';
import ShareButtons from '../../components/buttons/ShareButtons';
import {SimpleLoader} from '../../components/loading/simpleLoader';
import HealthCategoryNav from '../../components/NavigationBar/HealthCategoryNavigationBar';
import ShowAllProductsPage from './showAllProductsPage';
import {identifyClientType} from '../../utils/identifyClientType';
import {useClient} from '../../context/ClientContext';
import ShowLabTestsPage from './LabTestRecommendation';
import {
  calculateSkinHealthScore,
  getSkinDataFromStorage,
  getAcneSeverityScore,
  getSkinToneScore,
  getSkinTypeScore,
} from './helperfunctions';

export const ResultsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isClientResultsUrl = location.pathname.includes('client-results');
  console.log('isClientResultsUrl', isClientResultsUrl);
  const {theme: clientTheme, clientId} = useClient();
  const [sortedMetricsByHealthOrder, setSortedMetricsByHealthOrder] = useState([]);
  const [blurAndHide, setBlurAndHide] = useState(false);
  const [isShowAllResultsCard, setIsShowAllResultsCard] = useState(true);
  const [isLastProductPageVisible, setIsLastProductPageVisible] = useState(false);
  const [isGameCompleted, setIsGameCompleted] = useState(false);
  const [isAtplFlow, setIsAtplFlow] = useState(window.localStorage.getItem('from_atp') === 'true' ? true : false);
  const [isHelloHealthFlow, setIsHelloHealthFlow] = useState(
    window.localStorage.getItem('from_hellohealth') === 'true' ? true : false,
  );
  const [clientType, setClientType] = useState(() => {
    const orgId = parseInt(localStorage.getItem('organization_id'));
    if (!isNaN(orgId)) {
      return getClientTypeFromOrgId(orgId);
    }
    // If no org ID found, set default org ID and return default client type
    localStorage.setItem('organization_id', ORGANIZATION_IDS.DEFAULT.toString());
    return CLIENT_TYPES.DEFAULT;
  });
  const config = getClientConfig(clientType);

  useEffect(() => {
    setClientType(identifyClientType());
  }, []);

  useEffect(() => {
    let isGamePlayed = sessionStorage.getItem('isGamePlayed');
    setIsGameCompleted(isGamePlayed === 'true' ? true : false);
  }, []);

  // Then declare context
  const {userAssessmentID, setUserAssessmentID} = useContext(APIObjectsContext);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const {userPlan} = useContext(MiscContext);

  // APIs
  const nuralogixApi = useNuralogixApi();
  const assessmentApi = useAssessmentApi();
  const questionnaireApi = useQuestionnaireApi();
  const clientApi = useClientApi(clientType);

  // State declarations
  const [resultsData, setResultsData] = useState({});
  const [orgResultsData, setOrgResultsData] = useState(null);
  const [overallHealthScore, setOverallHealthScore] = useState({});
  const [overallHeartHealthScore, setOverallHeartHealthScore] = useState({});
  const [overallBodyFunctionScore, setBodyFunctionScore] = useState({});
  const [overallPhysicalHealthScore, setPhysicalHealthScore] = useState({});
  const [overallDiseaseRiskScore, setDiseaseRiskScore] = useState({});
  const [overallLiverHealthScore, setLiverHealthScore] = useState({});
  const [overallDiabetesRiskScore, setDiabetesRiskScore] = useState({});
  const [age, setAge] = useState(null);
  const [symptomCheckerResults, setSymptomCheckerResults] = useState([]);
  const [isVitalSignsRecord, setIsVitalSignsRecord] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [responseReturned, setResponseReturned] = useState(false);
  const [isSymptomCheckerPresent, setIsSymptomCheckerPresent] = useState(false);
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);
  const [isLoading, setIsLoading] = useState({
    loadingNuralogix: false,
    loadingSymptomChecker: false,
  });
  const [apiResults, setApiResults] = useState({
    isFaceScan: false,
    isSymptomChecker: false,
  });

  const [demographicsData, setDemographicsData] = useState({});
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('lg'));
  const [activeIndex, setActiveIndex] = useState(0);
  const [item, setItem] = useState(null);
  const [headerData, setHeaderData] = useState({
    name: 'Loading...',
    rating: '-',
    value: null,
  });
  const swiperRef = useRef(null); // Ref to access Swiper instance
  //this is for ATPL result overall page
  const [allOverallScoreForAtplResultCard, setAllOverallScoreForAtplResultCard] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      //get user demographics to extract age
      const demographics = await questionnaireApi.getQuestionnaire();

      if (demographics.status === 200) setDemographicsData(demographics.data);

      if (demographics.data.date_of_birth) {
        setAge(dayjs(demographics.data.date_of_birth).diff(dayjs(), 'year') * -1);
      }

      //get user assessment id
      const assessment = await assessmentApi.getLatestAssessment();
      if (assessment.status === 200) {
        setUserAssessmentID(assessment.data.id);
        if (assessment.data.symptoms_description !== null) {
          setIsSymptomCheckerPresent(true);
          const assessmentResults = await assessmentApi.getResultsAssessment(assessment.data.id);
          if (assessmentResults.status === 200) {
            const symptomsList = assessmentResults.data.conditions.map((condition, index) => {
              return {
                id: index,
                name: condition.name,
                probability: condition.probability,
                symptomColour: getThemeHexColor(),
              };
            });

            // Sort the symptomsList array based on probability in descending order
            symptomsList.sort((a, b) => b.probability - a.probability);

            // Get the top 3 items from the sorted array
            const top3Symptoms = symptomsList.slice(0, 3);

            setSymptomCheckerResults(top3Symptoms);
            setApiResults(prev => {
              return {
                ...prev,
                isSymptomChecker: true,
              };
            });
          } else {
            setIsSymptomCheckerPresent(false);
          }
        }
      }

      setResponseReturned(true);
      setIsLoading({
        loadingNuralogix: false,
        loadingSymptomChecker: false,
      });
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (clientType !== CLIENT_TYPES.DEFAULT) {
      const storedConditions = localStorage.getItem('conditions');
      if (storedConditions) {
        const conditions = JSON.parse(storedConditions);
        const symptomsList = conditions.map((condition, index) => ({
          id: index,
          name: condition.name,
          probability: condition.probability,
          symptomColour: getThemeHexColor(),
        }));

        // Sort by probability in descending order
        symptomsList.sort((a, b) => b.probability - a.probability);

        // Get top 3 symptoms
        const top3Symptoms = symptomsList.slice(0, 3);

        setSymptomCheckerResults(top3Symptoms);
        setIsSymptomCheckerPresent(true);
        setApiResults(prev => ({
          ...prev,
          isSymptomChecker: true,
        }));
      }
    }
  }, [clientType]); // Only run when clientType changes

  useEffect(() => {
    const fetchData = async () => {
      if (userAssessmentID == undefined) return;

      let resultsVitals;
      try {
        resultsVitals = await nuralogixApi.getNuralogixResultsVitals(userAssessmentID);
        setApiResults(prev => {
          return {
            ...prev,
            isFaceScan: true,
          };
        });
      } catch {
        setResponseReturned(true);
        setIsLoading({
          loadingNuralogix: false,
          loadingSymptomChecker: isSymptomCheckerPresent,
        });
        return;
      }

      const res = resultsVitals;
      console.log('res.data', res.data);
      setIsVitalSignsRecord(Object.keys(res.data).length > 0 ? true : false);

      const overallHealth = {
        title: 'Overall Health Score',
        result: res.data.overall_wellness,
      };

      const heartHealthScore = {
        heartHealthScoreVal: res.data.heart_disease_risk,
        bloodPressureSystolic: res.data.blood_pressure_systolic,
        bloodPressureDiastolic: res.data.blood_pressure_diastolic,
        irregularHeartBeatCount: res.data.irregular_heartbeat_count,
        breathRespiration: res.data.respiration,
        pulseRate: res.data.pulse_rate,
      };

      const bodyFunctionScore = {
        bodyFunctionScoreVal: res.data.mental_health_score,
        mentalStressIndex: res.data.stress_index,
        cardiacWorkload: res.data.cardiac_workload,
        heartRateVariability: res.data.heart_rate_change,
        vascularCapacity: res.data.vascular_capacity,
        vitalScore: res.data.vital_score,
        display: true,
        isPremium: true,
      };

      const physicalHealthScore = {
        physicalHealthScoreVal: res.data.physiological_health_score,
        bodyShapeIndex: res.data.body_shape_index,
        facialSkinAge: res.data.face_skin_age,
        bodyMassIndex: res.data.body_mass_index,
      };

      const diseaseRiskScore = {
        //        diseaseRiskScore: res.data.disease_risk_score,
        diseaseRiskScore: Math.ceil(
          (Number(res.data.cardiovascular_risk) +
            Number(res.data.hypertriglyceridemia_risk) +
            Number(res.data.heart_disease_risk) +
            Number(res.data.stroke_risk)) /
            4,
        ),
        cardiovascularRisk: res.data.cardiovascular_risk,
        hypertriglyceridemiaRisk: res.data.hypertriglyceridemia_risk,
        heartDiseaseRisk: res.data.heart_disease_risk,
        strokeRisk: res.data.stroke_risk,
      };

      const liverHealthScore = {
        fattyLiverDiseaseRisk: res.data.fatty_liver_disease_risk,
        hypertriglyceridemiaRisk: res.data.hypertriglyceridemia_risk,
      };

      const diabetesRiskScore = {
        diseaseRiskScoreVal: res.data.disease_risk_score,
        hba1cRisk: res.data.hba1c,
        bloodGlucose: res.data.blood_glucose,
        diabetesRisk: res.data.diabetes_risk,
      };

      const healthValuesToCompareAndFindLeastHealth = [
        {
          cardKey: '',
          'Overall Health Score': res.data.overall_wellness,
          healthName: 'Overall Health Score',
          category: null,
        },
        {
          cardKey: 'heartHealth',
          fieldValue: res.data.heart_disease_risk,
          healthName: 'Heart Health',
          category: 'Heart Health',
        },
        {
          cardKey: 'physicalHealth',
          fieldValue: res.data.physiological_health_score,
          healthName: 'Physical Health',
          category: 'Physical Health',
        },
        {
          cardKey: 'diseaseRisk',
          fieldValue: res.data.disease_risk_score,
          healthName: 'Overall Disease Risk',
          category: 'Overall Disease Risk',
        },
        {
          cardKey: 'diabetesRisk',
          fieldValue: res.data.diabetes_risk,
          healthName: 'diabetes risk',
          category: 'Diabetes Risk',
        },
        {
          cardKey: 'bodyFunction',
          fieldValue: res.data.mental_health_score,
          healthName: 'Body Function',
          category: 'Body Function',
        },
      ];

      gethealthMetricStatusNoAndComparetoFindLeastHealthStatus(healthValuesToCompareAndFindLeastHealth);

      setIsShowAllResultsCard(res?.data.show);
      setOverallHealthScore(overallHealth);
      setOverallHeartHealthScore(heartHealthScore);
      setBodyFunctionScore(bodyFunctionScore);
      setPhysicalHealthScore(physicalHealthScore);
      setDiseaseRiskScore(diseaseRiskScore);
      setLiverHealthScore(liverHealthScore);
      setDiabetesRiskScore(diabetesRiskScore);

      setResponseReturned(true);
      setIsLoading({
        loadingNuralogix: false,
        loadingSymptomChecker: isSymptomCheckerPresent,
      });
    };

    fetchData();
  }, [userAssessmentID, demographicsData]);

  // useEffect for organization data fetching
  useEffect(() => {
    const fetchOrgResults = async () => {
      console.log(clientType);
      if (clientType !== CLIENT_TYPES.DEFAULT) {
        try {
          const resultsToken = localStorage.getItem('results_token');
          const orgSessionId = localStorage.getItem('session-id');

          console.log(orgSessionId);
          let apiTocall = clientApi.getResults;
          if (orgSessionId && resultsToken) {
            if (isFromDoktor && isClientResultsUrl) {
              apiTocall = clientApi.showResultsAfterSingleSessionPayment;
            } else {
              apiTocall = clientApi.getResults;
            }
            const results = await apiTocall(orgSessionId);
            if (results.status === 200 && results.data.vitals) {
              setOrgResultsData(results.data.vitals);
              const dateOfBirth = JSON.parse(localStorage.getItem('userData'))?.dateOfBirth;
              // Calculate the age and set it
              if (dateOfBirth) {
                setAge(dayjs(dateOfBirth).diff(dayjs(), 'year') * -1);
              }

              if (isAtplFlow) {
                const dataForAtpResultPage = {
                  overallHealthScore: results.data.vitals.overall_wellness,
                  overallMentalHealthScore: results.data.vitals.mental_health_score,
                  overallLiverHealthScore: results.data.vitals.fatty_liver_disease_risk,
                  overallPhysicalHealthScore: results.data.vitals.physical_health_score,
                  overallHeartHealthScore: results.data.vitals.heart_disease_risk,
                  overalldiabetesRiskScore: results.data.vitals.diabetes_risk,
                  overalldiseaseRiskScore: results.data.vitals.disease_risk_score,
                };

                setAllOverallScoreForAtplResultCard(dataForAtpResultPage);
              }

              // Set initial states for org users
              setOverallHealthScore({
                title: 'Overall Health Score',
                result: results.data.vitals.overall_wellness,
              });

              setOverallHeartHealthScore({
                heartHealthScoreVal: results.data.vitals.heart_disease_risk,
                bloodPressureSystolic: results.data.vitals.blood_pressure_systolic,
                bloodPressureDiastolic: results.data.vitals.blood_pressure_diastolic,
                irregularHeartBeatCount: results.data.vitals.irregular_heartbeat_count,
                breathRespiration: results.data.vitals.respiration,
                pulseRate: results.data.vitals.pulse_rate,
              });

              setBodyFunctionScore({
                bodyFunctionScoreVal: results.data.vitals.mental_health_score,
                mentalStressIndex: results.data.vitals.stress_index,
                cardiacWorkload: results.data.vitals.cardiac_workload,
                heartRateVariability: results.data.vitals.heart_rate_change,
                vascularCapacity: results.data.vitals.vascular_capacity,
                vitalScore: results.data.vitals.vital_score,
                display: true,
                isPremium: true,
              });

              setPhysicalHealthScore({
                physicalHealthScoreVal: results.data.vitals.physiological_health_score,
                bodyShapeIndex: results.data.vitals.body_shape_index,
                facialSkinAge: results.data.vitals.face_skin_age,
                bodyMassIndex: results.data.vitals.body_mass_index,
              });

              setDiseaseRiskScore({
                diseaseRiskScore: results.data.vitals.disease_risk_score,
                cardiovascularRisk: results.data.vitals.cardiovascular_risk,
                hypertriglyceridemiaRisk: results.data.vitals.hypertriglyceridemia_risk,
                heartDiseaseRisk: results.data.vitals.heart_disease_risk,
                strokeRisk: results.data.vitals.stroke_risk,
              });

              setDiabetesRiskScore({
                diseaseRiskScoreVal: results.data.vitals.disease_risk_score,
                hba1cRisk: results.data.vitals.hba1c,
                bloodGlucose: results.data.vitals.blood_glucose,
                diabetesRisk: results.data.vitals.diabetes_risk,
              });
              if (isAtplFlow || isHelloHealthFlow) {
                const healthValuesToCompareAndFindLeastHealth = [
                  {
                    cardKey: '',
                    'Overall Health Score': results.data.vitals.overall_wellness,
                    healthName: 'Overall Health Score',
                    category: null,
                  },
                  {
                    cardKey: 'heartHealth',
                    fieldValue: results.data.vitals.heart_disease_risk,
                    healthName: 'Heart Health',
                    category: 'Heart Health',
                  },
                  {
                    cardKey: 'physicalHealth',
                    fieldValue: results.data.vitals.physiological_health_score,
                    healthName: 'Physical Health',
                    category: 'Physical Health',
                  },
                  {
                    cardKey: 'diseaseRisk',
                    fieldValue: results.data.vitals.disease_risk_score,
                    healthName: 'Overall Disease Risk',
                    category: 'Overall Disease Risk',
                  },
                  {
                    cardKey: 'diabetesRisk',
                    fieldValue: results.data.vitals.diabetes_risk,
                    healthName: 'diabetes risk',
                    category: 'Diabetes Risk',
                  },
                  {
                    cardKey: 'bodyFunction',
                    fieldValue: results.data.vitals.mental_health_score,
                    healthName: 'Body Function',
                    category: 'Body Function',
                  },
                ];

                gethealthMetricStatusNoAndComparetoFindLeastHealthStatus(healthValuesToCompareAndFindLeastHealth);
              }
            }
          }
        } catch (error) {
          console.error('Error fetching organization results:', error);
        }
        setIsLoading({
          loadingNuralogix: false,
          loadingSymptomChecker: isSymptomCheckerPresent,
        });
      }
    };

    fetchOrgResults();
  }, [clientType]);

  console.log(userAssessmentID, 'userAssessmentID');

  const isHandleOverlayVisibilty = data => {
    console.log(data);
    setIsOverlayVisible(data);
  };

  const onBackBtnClick = () => {
    if (window?.localStorage.getItem('organization_id') === '0') {
      navigate('/demographics');
    } else if (isAtplFlow) {
      atplBackButtonHandler();
    } else if (clientId) {
      navigate(`/${clientId}-health-profile`, {
        state: {
          flowComingFromResultPage: true,
        },
      });
    }
  };

  const gethealthMetricStatusNoAndComparetoFindLeastHealthStatus = dataArray => {
    console.log(dataArray);

    const updatedDataArray = dataArray.map(item => {
      console.log(item);

      // Skip the calculation for 'Overall Health Score'
      if (item?.healthName === 'Overall Health Score') {
        return item; // Return the item as is
      }

      console.log(item, item?.healthName, item.fieldValue);

      // Get the health function based on healthName (converted to lowercase)
      const gethelpweFUnctionToFetchOrderNo = getHealthFunctions(item?.healthName?.toLowerCase());

      // Check if gethelpweFUnctionToFetchOrderNo is valid and has the method 'getScoreStatusByNo'
      if (gethelpweFUnctionToFetchOrderNo && typeof gethelpweFUnctionToFetchOrderNo.getScoreStatusByNo === 'function') {
        const healthOrderNo = gethelpweFUnctionToFetchOrderNo.getScoreStatusByNo(item.fieldValue);
        return {
          ...item, // Preserve the original data
          healthOrderNo, // Add the calculated healthOrderNo
        };
      } else {
        console.warn(`No valid function found for healthName: ${item?.healthName}`);
        return item; // Return the item as is if the function is not available
      }
    });

    // Now sort the array based on healthOrderNo in ascending order
    updatedDataArray.sort((a, b) => a.healthOrderNo - b.healthOrderNo);
    console.log(updatedDataArray);

    setSortedMetricsByHealthOrder(updatedDataArray);
    // Return the sorted array
    return updatedDataArray;
  };

  const getInitialComponentData = () => {
    // Check if components are available
    const components = getcomponents().filter(Boolean);
    if (components.length === 0) {
      return {
        headerData: {
          name: 'Loading...',
          rating: '-',
          value: null,
        },
        item: null,
      };
    }

    // If symptom checker results exist, prioritize that
    if (symptomCheckerResults.length > 0) {
      return {
        headerData: {
          name: overallHealthScore?.title || 'Overall Health Score',
          rating: overallHealthScore.result,
          value: overallHealthScore.result,
        },
      };
    }

    // If no symptoms, use first component (which should be Heart Health)
    const firstComponent = components[0];
    if (firstComponent.props?.item) {
      return {
        headerData: {
          name: firstComponent.props.item.name || 'Heart Health',
          rating: firstComponent.props.item.rating || '-',
          value: firstComponent.props.item.value || null,
        },
        item: firstComponent.props.item,
      };
    }

    return {
      headerData: {
        name: 'Heart Health',
        rating: '-',
        value: null,
      },
      item: null,
    };
  };

  const handleCategorySelect = index => {
    setActiveCategoryIndex(index);
    // Make sure to update the swiper when a category is clicked
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(index);
    }
  };

  const handleSlideChange = swiper => {
    if (!swiper) return;

    const activeSlideIndex = swiper.activeIndex;
    const components = getcomponents().filter(Boolean);
    const isLastComponent = swiper.activeIndex === components.length - 1; // Last index

    // Only proceed if we have valid components and index
    if (components.length > 0 && components[activeSlideIndex]) {
      // First thing - update the category nav index
      setActiveCategoryIndex(activeSlideIndex);

      // Handle slide change
      if (activeSlideIndex === 0 && symptomCheckerResults.length > 0) {
        // Symptom checker first slide
        setHeaderData({
          name: overallHealthScore.title,
          rating: overallHealthScore.result,
          value: overallHealthScore.result,
        });
        setIsLastProductPageVisible(false);
      } else if ((isAtplFlow || clientType == CLIENT_TYPES.DEFAULT) && isLastComponent) {
        setIsLastProductPageVisible(true);
        setHeaderData({
          name: 'Top Products for You',
          rating: '',
          value: '',
        });
      } else if (isHelloHealthFlow && isLastComponent) {
        setIsLastProductPageVisible(true);
        setHeaderData({
          name: 'Lab Tests For You',
          rating: '',
          value: '',
        });
      } else if (
        isHelloHealthFlow &&
        (symptomCheckerResults.length > 0 ? activeSlideIndex === 6 : activeSlideIndex === 5)
      ) {
        setHeaderData({
          name: 'Top Products for You',
          rating: '',
          value: '',
        });
      } else {
        // Other slides (including first slide if no symptoms)
        const currentItem = components[activeSlideIndex]?.props?.item;
        setHeaderData({
          name: currentItem?.name || 'Heart Health',
          rating: currentItem?.rating || '-',
          value: currentItem?.value,
        });
        setIsLastProductPageVisible(false);
      }

      setActiveIndex(activeSlideIndex);
      setItem(components[activeSlideIndex]?.props?.item);
    }
  };

  // Compute categories separately
  const computeCategories = () => {
    const tempComponents = [
      ...(symptomCheckerResults.length > 0 ? [{key: 'allHealth', props: {item: null}}] : []),
      {key: 'heartHealth', props: {item: {name: 'Heart Health'}}},
      {key: 'bodyFunction', props: {item: {name: 'Body Function'}}},
      {key: 'physicalHealth', props: {item: {name: 'Physical Health'}}},
      clientType == CLIENT_TYPES.DEFAULT && {key: 'skinHealth', props: {item: {name: 'Skin Health'}}},
      {key: 'diseaseRisk', props: {item: {name: 'Disease Risk'}}},
      {key: 'diabetesRisk', props: {item: {name: 'Metabolic Health'}}},
      {key: 'products', props: {item: {name: 'Products'}}},
      {key: 'labtest', props: {item: {name: 'Lab Test'}}},
    ].filter(Boolean);

    return tempComponents.map((component, index) => {
      if (component.props?.item) {
        return {
          id: component.key || `category-${index}`,
          name: component.props.item.name || `Category ${index}`,
        };
      } else if (symptomCheckerResults.length > 0 && index === 0) {
        return {
          id: 'overallHealth',
          name: 'Overall Health' || 'Overall Health',
        };
      } else if (isAtplFlow && index === 0) {
        return {
          id: 'atplResult',
          name: 'Health Score',
        };
      } else {
        return {
          id: `allHealth`,
          name: `Symptom Checker Results`,
        };
      }
    });
  };

  // Use React.useMemo to ensure the categories are computed only when dependencies change
  const categories = React.useMemo(() => computeCategories(), [isAtplFlow, symptomCheckerResults, overallHealthScore]);

  const getcomponents = () => [
    ...(symptomCheckerResults.length > 0
      ? [
          <AllHealthScore
            key="allHealth"
            value={overallHealthScore.result}
            title={overallHealthScore.title}
            symptoms={symptomCheckerResults}
            onBackBtnClick={onBackBtnClick}
            activeCategoryIndex={activeCategoryIndex}
            handleCategorySelect={handleCategorySelect}
            getCategories={categories}
            isShowAllResultsCard={isShowAllResultsCard}
            findProductBtnHandlerForSymptomPage={findProductBtnHandlerForSymptomPage}
          />,
        ]
      : []),

    <CarouselPage
      isHandleOverlayVisibilty={isHandleOverlayVisibilty}
      key="heartHealth"
      onBackBtnClick={onBackBtnClick}
      activeCategoryIndex={activeCategoryIndex}
      handleCategorySelect={handleCategorySelect}
      getCategories={categories}
      isShowAllResultsCard={isShowAllResultsCard}
      handleUpgradeToSeeResults={handleUpgradeToSeeResults}
      item={{
        userAssessmentID: userAssessmentID,
        name: 'Heart Health',
        rating: 'Low',
        value: overallHeartHealthScore.heartHealthScoreVal,
        isGameCompleted: isGameCompleted,
        results: [
          {
            name: 'Blood Pressure',
            symbol: isAtplFlow || isHelloHealthFlow ? '/others/atplResultsIcon/orange_bp.svg' : '/others/mmh.svg',
            label: 'mmHg',
            value: overallHeartHealthScore.bloodPressureSystolic,
            diastolicbp: overallHeartHealthScore.bloodPressureDiastolic,
            ratings: {
              low: [0, 90],
              optimal: [90, 120],
              normal: [120, 130],
              elevated: [130, 140],
              high: [140, 180],
            },
            diastolicbpRatings: {
              low: [0, 60],
              optimal: [60, 80],
              normal: [80, 84],
              elevated: [85, 89],
              high: [90, 120],
            },

            diastolicbpDescription:
              'Diastolic blood pressure is the pressure in your arteries when your heart is resting between beats. Low numbers could mean your heart is resting well between beats, which is good, but too low might indicate not enough pressure to push blood to all parts of your body, which is not good. ',
            description:
              'Systolic blood pressure is the pressure in your arteries when your heart beats and pushes out blood. High values are bad, indicating potential hypertension; low values might be good but can be concerning if too low.',
          },
          {
            name: 'Irregular Heartbeat Count',
            symbol:
              isAtplFlow || isHelloHealthFlow
                ? '/others/atplResultsIcon/orange_stethoscope.svg'
                : '/others/stethoscope.svg',
            label: 'beats',
            value: overallHeartHealthScore.irregularHeartBeatCount,
            ratings: {
              normal: [0, 0],
              elevated: [1, 4],
              high: [5, 10],
            },
            description:
              'Number of irregular heartbeats. If you have irregular heartbeats, it can mean your heart might not be pumping blood as smoothly as it should and may signal heart problems.',
          },
          {
            name: 'Heart Rate',
            symbol:
              isAtplFlow || isHelloHealthFlow ? '/others/atplResultsIcon/orange_heart.svg' : '/others/heart-sharp.svg',
            label: 'bpm',
            value: overallHeartHealthScore.pulseRate,
            ratings: {
              low: [0, 40],
              optimal: [40, 60],
              normal: [60, 100],
              elevated: [100, 140],
            },
            description:
              'Pulse is the number of times your heart beats in one minute. This shows how hard your heart is working to pump blood around your body. Low values are usually good for resting adults, indicating a healthy heart, but too low might signal a problem whereas high values may indicate stress or heart issues.',
          },
        ],
      }}
    />,

    <CarouselPage
      isHandleOverlayVisibilty={isHandleOverlayVisibilty}
      key="bodyFunction"
      onBackBtnClick={onBackBtnClick}
      activeCategoryIndex={activeCategoryIndex}
      handleCategorySelect={handleCategorySelect}
      getCategories={categories}
      isShowAllResultsCard={isShowAllResultsCard}
      handleUpgradeToSeeResults={handleUpgradeToSeeResults}
      item={{
        userAssessmentID: userAssessmentID,
        name: 'Body Function',
        rating: 'Low',
        value: overallBodyFunctionScore.bodyFunctionScoreVal,
        isGameCompleted: isGameCompleted,
        results: [
          {
            name: 'Mental Stress Index',
            symbol: isAtplFlow || isHelloHealthFlow ? '/others/atplResultsIcon/orange_brain.svg' : '/others/brain.svg',
            label: '',
            value: overallBodyFunctionScore.mentalStressIndex,
            ratings: {
              optimal: [1, 2],
              normal: [2, 3],
              'high normal': [3, 4],
              elevated: [4, 5],
            },
            description:
              'Mental Stress Index assesses overall stress levels. High levels indicate excessive stress; low levels suggest good stress management or low stress.',
          },
          {
            name: 'Cardiac Workload',
            symbol:
              isAtplFlow || isHelloHealthFlow ? '/others/atplResultsIcon/orange_heart.svg' : '/others/heart-pulse.svg',
            label: 'dB',
            value: overallBodyFunctionScore.cardiacWorkload,
            ratings: {
              optimal: [0, 3.8],
              normal: [3.8, 3.9],
              'high normal': [3.9, 4.08],
              elevated: [4.08, 4.18],
              high: [4.18, 8.28],
            },
            description:
              'Cardiac Workload reflects how hard the heart works. High workload can stress the heart, while too low might show insufficient blood pumping.',
          },
          {
            name: 'Heart Rate Variability',
            symbol:
              isAtplFlow || isHelloHealthFlow
                ? '/others/atplResultsIcon/orange_stethoscope.svg'
                : '/others/stethoscope.svg',
            label: 'ms',
            value: overallBodyFunctionScore.heartRateVariability,
            ratings: {
              'very low': [0, 10.8],
              low: [10.8, 16.4],
              'low normal': [16.4, 35.5],
              normal: [35.5, 51.5],
              optimal: [51.5, 80],
            },
            description:
              'Heart rate variability is the variation in time between heartbeats. High variability is often a sign of a healthy heart, while low variability can indicate stress or cardiac health issues.',
          },

          {
            name: 'Vascular Capacity',
            symbol:
              isAtplFlow || isHelloHealthFlow ? '/others/atplResultsIcon/orange_droplet.svg' : '/others/droplet.svg',
            label: 'sec',
            value: overallBodyFunctionScore.vascularCapacity,
            ratings: {
              'very low': [0, 0.79],
              low: [0.79, 1.12],
              'low normal': [1.12, 1.78],
              normal: [1.78, 2.11],
              optimal: [2.11, 15],
            },
            description:
              'Vascular Capacity indicates the health and function of blood vessels. High capacity suggests good blood flow and health; low capacity can signal cardiovascular issues.',
          },
        ],
      }}
    />,

    <CarouselPage
      isHandleOverlayVisibilty={isHandleOverlayVisibilty}
      onBackBtnClick={onBackBtnClick}
      key="physicalHealth"
      activeCategoryIndex={activeCategoryIndex}
      handleCategorySelect={handleCategorySelect}
      getCategories={categories}
      isShowAllResultsCard={isShowAllResultsCard}
      handleUpgradeToSeeResults={handleUpgradeToSeeResults}
      item={{
        userAssessmentID: userAssessmentID,
        name: 'Physical Health',
        rating: 'Low',
        value: overallPhysicalHealthScore.physicalHealthScoreVal,
        isGameCompleted: isGameCompleted,
        results: [
          {
            name: 'Body Mass Index',
            symbol:
              isAtplFlow || isHelloHealthFlow
                ? '/others/atplResultsIcon/orange-weight-hanging.svg'
                : '/others/weight-hanging.svg',
            label: 'kg/m²',
            value: overallPhysicalHealthScore.bodyMassIndex,
            ratings: {
              scheme: 'bmi',
              underweight: [0, 18.5],
              normal: [18.5, 25],
              overweight: [25, 30],
              obese: [30, 60],
            },
            description:
              'BMI or Body Mass Index calculates body fat based on height and weight. High BMI indicates overweight/obesity; low BMI could mean underweight.',
          },
          {
            name: 'Body Shape Index',
            symbol:
              isAtplFlow || isHelloHealthFlow
                ? '/others/atplResultsIcon/orange-weight-scale.svg'
                : '/others/weight-scale.svg',
            label: '',
            value: overallPhysicalHealthScore.bodyShapeIndex,
            ratings: {
              optimal: [0, 6.8],
              normal: [7.1, 7.6],
              'high normal': [7.6, 8.6],
              elevated: [8.6, 9.1],
              high: [9.1, 9.6],
            },
            description:
              'Body Shape Index (BSI) is a measure of body shape and health risks. Higher values can suggest a higher risk of heart disease; lower values indicate lower risk.',
          },
          {
            name: 'Breathing Rate',
            symbol: isAtplFlow || isHelloHealthFlow ? '/others/atplResultsIcon/orange_wind_.svg' : '/others/wind.svg',
            label: 'brpm',
            value: overallHeartHealthScore.breathRespiration,
            ratings: {
              low: [0, 11],
              optimal: [12, 24],
              high: [25, 35],
            },
            description:
              'Breathing rate is the number of times you breathe in and out in a minute. This tells you if your lungs are providing enough oxygen to your body without too much effort. Both very high and very low rates can be bad, indicating potential breathing or health issues.',
          },
        ],
      }}
    />,

    clientType === CLIENT_TYPES.DEFAULT && (
      <CarouselPage
        isHandleOverlayVisibilty={isHandleOverlayVisibilty}
        key="skinHealth"
        onBackBtnClick={onBackBtnClick}
        activeCategoryIndex={activeCategoryIndex}
        handleCategorySelect={handleCategorySelect}
        getCategories={categories}
        isShowAllResultsCard={isShowAllResultsCard}
        handleUpgradeToSeeResults={handleUpgradeToSeeResults}
        item={{
          userAssessmentID: userAssessmentID,
          name: 'Skin Health',
          rating: 'Low', // You can calculate this based on skin metrics
          value: calculateSkinHealthScore(), // You'll need to implement this function
          isGameCompleted: isGameCompleted,
          results: [
            {
              name: 'Facial Skin Age',
              symbol:
                isAtplFlow || isHelloHealthFlow
                  ? '/others/atplResultsIcon/orange_female-icon.png'
                  : '/others/womanface.svg',
              label: 'years',
              value: overallPhysicalHealthScore.facialSkinAge,
              ratings: {
                scheme: 'age',
                younger: [0, age],
                normal: [age, age + 1],
                older: [age + 1, 100],
              },
              description: 'AI-estimated facial skin age compared to chronological age using computer vision analysis.',
            },
            {
              name: 'Skin Clarity',
              symbol: isAtplFlow || isHelloHealthFlow ? '/others/atplResultsIcon/orange_acne.svg' : '/others/acne.png',
              label: '/100',
              value: getAcneSeverityScore(getSkinDataFromStorage('acne')),
              ratings: {
                scheme: 'acne_health',
                poor: [0, 30], // Severe acne
                moderate: [30, 70], // Moderate acne
                good: [70, 100], // Clear/Low acne
              },
              description: 'AI-estimated skin clarity that indicates the level of acne concern.',
              confidence: 68, // Model accuracy
            },
            {
              name: 'Skin Tone',
              symbol:
                isAtplFlow || isHelloHealthFlow ? '/others/atplResultsIcon/orange_tone.svg' : '/others/skin-tone.png',
              label: '/100',
              value: getSkinToneScore(getSkinDataFromStorage('tone')),
              ratings: {
                scheme: 'tone_quality',
                poor: [0, 30],
                fair: [30, 50],
                good: [50, 70],
                very_good: [70, 85],
                excellent: [85, 100],
              },
              description: 'Skin tone uniformity analyzed according to the Fitzpatrick scale.',
              confidence: 80,
            },
            {
              name: 'Skin Balance',
              symbol:
                isAtplFlow || isHelloHealthFlow ? '/others/atplResultsIcon/orange_droplet.svg' : '/others/droplet.svg',
              label: '/100',
              value: getSkinTypeScore(getSkinDataFromStorage('type')),
              ratings: {
                scheme: 'skin_balance',
                needs_care: [0, 70], // Dry/Oily (needs attention)
                balanced: [70, 95], // Good balance
                optimal: [95, 100], // Normal (ideal)
              },
              description:
                'Skin balance measure indicating the oil-moisture ratio. Normal skin indicates optimal oil-moisture balance.',
              confidence: 87,
            },
          ],
        }}
      />
    ),

    <CarouselPage
      isHandleOverlayVisibilty={isHandleOverlayVisibilty}
      key="diseaseRisk"
      onBackBtnClick={onBackBtnClick}
      activeCategoryIndex={activeCategoryIndex}
      handleCategorySelect={handleCategorySelect}
      getCategories={categories}
      isShowAllResultsCard={isShowAllResultsCard}
      handleUpgradeToSeeResults={handleUpgradeToSeeResults}
      item={{
        userAssessmentID: userAssessmentID,
        name: 'Overall Disease Risk',
        rating: 'Low',
        value: overallDiseaseRiskScore.diseaseRiskScore,
        isGameCompleted: isGameCompleted,
        results: [
          {
            name: 'Cardiovascular Risk',
            symbol: null,
            percentSign: '%',
            value: overallDiseaseRiskScore.cardiovascularRisk,
            ratings: {
              scheme: 'risk',
              'very low': [0, 5],
              low: [5, 7.25],
              moderate: [7.25, 10],
              high: [10, 20],
              'very high': [20, 100],
            },
            description:
              'Cardiovascular Disease Risk is the likelihood of developing heart-related conditions. Higher risk requires lifestyle changes; lower risk suggests good heart health.',
          },
          {
            name: 'Hypertriglyceridemia Risk',
            symbol: null,
            percentSign: '%',
            value: overallDiseaseRiskScore.hypertriglyceridemiaRisk,
            ratings: {
              scheme: 'risk',
              'very low': [0, 25],
              low: [25, 45],
              moderate: [45, 55],
              high: [55, 77.5],
              'very high': [77.5, 100],
            },
            description:
              'Hypertriglyceridemia Risk is the chance of elevated triglycerides in blood in the next 10 years. High risk indicates potential for heart issues; lower risk is better.',
          },
          {
            name: 'Heart Disease Risk',
            symbol: null,
            percentSign: '%',
            value: overallDiseaseRiskScore.heartDiseaseRisk,
            ratings: {
              scheme: 'risk',
              'very low': [0, 5],
              low: [5, 7.25],
              moderate: [7.25, 10],
              high: [10, 20],
              'very high': [20, 100],
            },
            description:
              'Heart Disease Risk indicates the probability of developing conditions affecting the heart. Higher risk may require medical intervention and lifestyle changes; lower risk reflects better heart health.',
          },
          {
            name: 'Stroke Risk',
            symbol: null,
            percentSign: '%',
            value: overallDiseaseRiskScore.strokeRisk,
            ratings: {
              scheme: 'risk',
              'very low': [0, 3.3],
              low: [3.3, 4.79],
              moderate: [4.79, 6.6],
              high: [6.6, 13.2],
              'very high': [13.2, 100],
            },
            description:
              'Stroke Risk is the probability of suffering a stroke in the next 10 years. Higher risk highlights the need for intervention; lower risk indicates less cause for concern.',
          },
        ],
      }}
    />,

    <CarouselPage
      key="diabetesRisk"
      isHandleOverlayVisibilty={isHandleOverlayVisibilty}
      isLastRrsultCard={true}
      onBackBtnClick={onBackBtnClick}
      activeCategoryIndex={activeCategoryIndex}
      handleCategorySelect={handleCategorySelect}
      getCategories={categories}
      isShowAllResultsCard={isShowAllResultsCard}
      handleUpgradeToSeeResults={handleUpgradeToSeeResults}
      item={{
        userAssessmentID: userAssessmentID,
        name: 'Metabolic Health',
        rating: 'Low',
        value: overallDiabetesRiskScore.diabetesRisk,
        isGameCompleted: isGameCompleted,
        results: [
          {
            name: 'Risk of HbA1c >5.7%',
            symbol: null,
            percentSign: '%',
            value: overallDiabetesRiskScore.hba1cRisk,
            ratings: {
              scheme: 'risk',
              'very low': [0, 25],
              low: [25, 45],
              moderate: [45, 55],
              high: [55, 77.5],
              'very high': [77.5, 100],
            },
            description:
              'Hemoglobin A1C Risk is the risk of higher than normal A1C levels, indicating diabetes risk. High levels necessitate action; lower levels are preferred.',
          },
          {
            name: 'Fasting Blood Glucose >5.5mmol/L',
            symbol: null,
            percentSign: '%',
            value: overallDiabetesRiskScore.bloodGlucose,
            ratings: {
              scheme: 'risk',
              'very low': [0, 25],
              low: [25, 45],
              moderate: [45, 55],
              high: [55, 77.5],
              'very high': [77.5, 100],
            },
            description:
              'Fasting Blood Glucose Risk is the chance of having high fasting blood sugar. High levels indicate diabetes risk; lower levels are normal.',
          },
          {
            name: 'Type  2 Diabetes Risk',
            symbol: null,
            percentSign: '%',
            value: overallDiabetesRiskScore.diabetesRisk,
            ratings: {
              scheme: 'risk',
              'very low': [0, 25],
              low: [25, 45],
              moderate: [45, 55],
              high: [55, 77.5],
              'very high': [77.5, 100],
            },
            description:
              'Type 2 Diabetes Risk is the likelihood of developing type 2 diabetes in the next 10 years. High risk necessitates preventive actions; low risk means less worry.',
          },
        ],
      }}
    />,
    (isAtplFlow || isHelloHealthFlow || clientType == CLIENT_TYPES.DEFAULT) && (
      <Stack key="allProdPage">
        <ShowAllProductsPage
          onBackBtnClick={onBackBtnClick}
          getCategories={categories}
          handleCategorySelect={handleCategorySelect}
          activeCategoryIndex={activeCategoryIndex}
          sortedMetricsByHealthOrder={sortedMetricsByHealthOrder}
          blurAndHide={blurAndHide}
          handleNavigation={learMoreResponsivePageBtnHandler}
        ></ShowAllProductsPage>
      </Stack>
    ),
    isHelloHealthFlow && (
      <Stack key="labtest">
        <ShowLabTestsPage
          onBackBtnClick={onBackBtnClick}
          getCategories={categories}
          handleCategorySelect={handleCategorySelect}
          activeCategoryIndex={activeCategoryIndex}
          sortedMetricsByHealthOrder={sortedMetricsByHealthOrder}
          blurAndHide={blurAndHide}
          handleNavigation={learMoreResponsivePageBtnHandler}
          item={{name: 'Recommended Lab Test'}}
        />
      </Stack>
    ),
  ];

  const learnMOreBtnHandler = () => {
    let itemTosend = null;
    // Make sure sortedMetricsByHealthOrder is not empty
    if (sortedMetricsByHealthOrder.length) {
      let stopLoop = false; // Flag to stop the loop

      sortedMetricsByHealthOrder.forEach(sortedMetrics => {
        // If stopLoop is true, break out of the loop early
        if (stopLoop) return;

        if (sortedMetrics.healthName !== 'Overall Health Score') {
          getcomponents()
            .filter(Boolean)
            .forEach(data => {
              if (data.key === sortedMetrics.cardKey) {
                console.log('ging here correctly');
                console.log(data.props.item);

                setItem(data.props.item);

                stopLoop = true;
                itemTosend = data.props.item;
                return;
              }
            });
        }
      });

      return itemTosend; // Return the item at the end of the function
    }
  };

  const learMoreResponsivePageBtnHandler = () => {
    const item = learnMOreBtnHandler();
    navigate('/results/analysis', {state: {item}});
  };

  useEffect(() => {
    if (isLastProductPageVisible) {
      learnMOreBtnHandler();
    }
  }, [isLastProductPageVisible]);

  useEffect(() => {
    // Show the initial image on component mount
    setCurrentIndex(0);
  }, []);

  // useEffect to properly handle initial data
  useEffect(() => {
    if (!isLoading.loadingNuralogix) {
      const initialData = getInitialComponentData();
      setHeaderData(initialData.headerData);
      setItem(initialData.item);
    }
  }, [
    isLoading.loadingNuralogix,
    overallHealthScore,
    overallHeartHealthScore,
    overallBodyFunctionScore,
    overallPhysicalHealthScore,
    overallDiseaseRiskScore,
    overallLiverHealthScore,
    overallDiabetesRiskScore,
    allOverallScoreForAtplResultCard,
    symptomCheckerResults,
  ]);

  const healthFunctions = getHealthFunctions(headerData.name);
  const statusColor = healthFunctions.getColor(headerData.value);
  const statusText = healthFunctions.getStatus(headerData.value);
  const paramValue = healthFunctions.getScaledValue(headerData.value);
  const cardRef = useRef(null);

  const [isFromDoktor, setIsFromDoktor] = useState(false);

  useEffect(() => {
    // Check localStorage for the flag
    const fromDoktor = window.localStorage.getItem('from_doktor');
    setIsFromDoktor(fromDoktor === 'true');
  }, []);

  // Recalculate blur effect whenever any of the dependencies change
  useEffect(() => {
    const blurCondition = shouldBlur(
      headerData,
      isShowAllResultsCard,
      isFromDoktor,
      isGameCompleted,
      isClientResultsUrl,
    );

    setBlurAndHide(blurCondition); // Set the boolean state to true/false based on the condition
  }, [isShowAllResultsCard, headerData, isFromDoktor, isGameCompleted, isClientResultsUrl, clientType]); // Dependencies for recalculation

  //back button logic fro ATPL flow
  const atplBackButtonHandler = () => {
    if (swiperRef.current.swiper.activeIndex == 0) {
      localStorage.setItem('flowComingFromAtpResultPage', 'true');
      navigate('/atpl-health-profile');
    } else {
      // on card back btn click show 1st card
      if (swiperRef.current) {
        swiperRef.current.swiper.slideTo('0'); // Change slide programmatically
        setCurrentIndex('0');
      }
    }
  };

  const findProductBtnHandlerForSymptomPage = () => {
    const components = getcomponents().filter(Boolean);
    const lastIndex = components.length - 1; // Last index
    if (swiperRef.current) {
      swiperRef.current.swiper.slideTo(lastIndex); // Change slide programmatically
      setCurrentIndex(lastIndex);
    }
  };

  // Helper function to check the blur condition
  const shouldBlur = (headerData, isShowAllResultsCard, isFromDoktor, isGameCompleted, isClientResultsUrl) => {
    const blurCategories = [
      'Physical Health',
      'Overall Disease Risk',
      'Metabolic Health',
      'Skin Health',
      'Product Page',
    ];

    // Check if the category is one of the blur categories
    const isBlurCategory = blurCategories.includes(headerData.name);

    // Logic for blurring the card
    return (
      (clientType === CLIENT_TYPES.DEFAULT && !isShowAllResultsCard && isBlurCategory) ||
      (isFromDoktor && !isGameCompleted && !isClientResultsUrl && isBlurCategory)
    );
  };

  const handleUpgradeToSeeResults = () => {
    navigate('/plans', {
      state: {
        flowComingFromResultPage: true, // Pass the state here
      },
    });
  };

  return (
    <>
      {isFromDoktor && isOverlayVisible && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
          }}
        />
      )}

      {isLargeScreen ? (
        // Large screen layout
        <div className="large-parent-div-1">
          <div className="large-parent-div">
            {isLoading.loadingNuralogix && isLoading.loadingSymptomChecker ? (
              isAtplFlow || isHelloHealthFlow ? (
                <SimpleLoader loadingText="Loading..." textColor="#F15C30" />
              ) : (
                <AnimationLoadingScreenWithProgressBar
                  title="Loading..."
                  secondsToLoad={60}
                  isAlmostComplete={responseReturned}
                />
              )
            ) : (
              <Stack className="large-sliders-container">
                {/* Top Header */}
                <Stack className="top-header" display="flex" flexDirection="row" padding="16px 0px 8px 0px">
                  <Box
                    style={{
                      textDecoration: 'none',
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Stack onClick={onBackBtnClick} display="flex" flexDirection="row" style={{cursor: 'pointer'}}>
                      {!isFromDoktor && config?.backButton}
                    </Stack>

                    <Stack sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                      <Typography
                        sx={{
                          cursor: 'pointer',
                          color: config?.colors?.primary,
                          variant: 'p',
                          component: 'p',
                          fontWeight: '600',
                          fontSize: '14px',
                          textAlign: 'end',
                        }}
                        onClick={() => {
                          const nextUrl = config?.urls?.nextButtonUrl;
                          const isExternal = nextUrl.startsWith('http');

                          if (isExternal) {
                            window.open(nextUrl, '_blank'); // Open external URL in new tab
                          } else {
                            navigate(nextUrl); // Internal route
                          }
                        }}
                      >
                        Next
                      </Typography>
                      <ArrowForwardIcon
                        sx={{
                          fontSize: '16px',
                          padding: '0px 2px 0px 4px',
                          cursor: 'pointer',
                          color: config?.colors?.primary,
                        }}
                      />
                    </Stack>
                  </Box>
                </Stack>

                {/* Header Content */}
                <Stack
                  className="top-header"
                  display="flex"
                  alignItems="center"
                  flexDirection="row"
                  justifyContent="space-between"
                  paddingTop="0px"
                  paddingX="50px"
                  paddingBottom={
                    (isAtplFlow || isHelloHealthFlow || clientType === CLIENT_TYPES.DEFAULT) && isLastProductPageVisible
                      ? '30px'
                      : undefined
                  }
                >
                  <Stack>
                    <Typography color="black" variant="h4" component="h4" fontWeight="bold" sx={{fontSize: '23px'}}>
                      {(isAtplFlow || clientType === CLIENT_TYPES.DEFAULT) &&
                      isLastProductPageVisible &&
                      activeIndex == getcomponents().filter(Boolean).length - 1
                        ? 'Top Products for You'
                        : headerData.name}
                    </Typography>
                    {(isAtplFlow || clientType === CLIENT_TYPES.DEFAULT) &&
                    isLastProductPageVisible &&
                    activeIndex == getcomponents().filter(Boolean).length - 1 ? (
                      <Typography
                        sx={{
                          color: '#545454',
                          fontSize: '15px',
                          fontWeight: 600,
                          textAlign: 'center',
                        }}
                      >
                        Our recommendations to elevate your health in your weakest health categories.
                      </Typography>
                    ) : (
                      <Typography
                        color={statusColor}
                        variant="p"
                        component="p"
                        fontWeight="600"
                        display={
                          isHelloHealthFlow &&
                          (symptomCheckerResults.length == 0
                            ? activeIndex === 6 || activeIndex === 5
                            : activeIndex === 7 || activeIndex === 6)
                            ? 'none'
                            : 'block'
                        }
                        sx={{
                          fontSize: '15px',
                          filter: blurAndHide ? 'blur(6px)' : 'blur(0px)',
                        }}
                      >
                        {statusText}
                      </Typography>
                    )}

                    {isHelloHealthFlow && activeIndex == getcomponents().filter(Boolean).length - 1 && (
                      <Typography
                        sx={{
                          color: '#545454',
                          fontSize: '15px',
                          fontWeight: 600,
                          textAlign: 'center',
                        }}
                      >
                        Our recommended lab tests based on your results.
                      </Typography>
                    )}
                    {isHelloHealthFlow && (symptomCheckerResults.length > 0 ? activeIndex == 6 : activeIndex == 5) && (
                      <Typography
                        sx={{
                          color: '#545454',
                          fontSize: '15px',
                          fontWeight: 600,
                          textAlign: 'center',
                        }}
                      >
                        Our recommendations to elevate your health in your weakest health categories.
                      </Typography>
                    )}
                  </Stack>

                  {/* Progress Bar */}
                  {(isAtplFlow || isHelloHealthFlow || clientType == CLIENT_TYPES.DEFAULT) &&
                  isLastProductPageVisible ? (
                    ''
                  ) : (
                    <div
                      style={{
                        position: 'relative',
                        width: '80px',
                        height: '80px',
                        background: '#fff',
                      }}
                    >
                      <Box position="relative" display="inline-flex">
                        <DynamicProgressBar
                          paramValue={blurAndHide ? '100' : Number(Math.round(paramValue))}
                          paramSize={80}
                          paramThickness={8}
                          barColor={blurAndHide ? '#D9D9D9' : statusColor}
                          storkeColor={isAtplFlow && activeIndex === 0 && statusColor}
                        />
                        <Typography
                          variant="h6"
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                          }}
                          sx={{
                            fontWeight: 'bold',
                            filter: blurAndHide ? 'blur(6px)' : 'blur(0px)',
                          }}
                        >
                          {Number(Math.round(headerData.value))}
                        </Typography>
                      </Box>
                    </div>
                  )}
                </Stack>

                {/* Swiper Component */}
                <Box
                  sx={{position: 'relative', bottom: isAtplFlow || isHelloHealthFlow || isFromDoktor ? '16px' : '0px'}}
                >
                  <Swiper
                    ref={swiperRef}
                    effect={'coverflow'}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={2}
                    coverflowEffect={{
                      rotate: 0,
                      stretch: 0,
                      depth: 100,
                      modifier: 2.5,
                      slideShadows: false,
                    }}
                    pagination={config?.swiperConfig?.isSwiperPagination ? {clickable: true} : false}
                    navigation={config?.swiperConfig?.isSwiperNavigation ? true : false}
                    modules={[EffectCoverflow, Pagination, Navigation]}
                    onSlideChange={handleSlideChange}
                    onSwiper={swiper => handleSlideChange(swiper)}
                  >
                    {getcomponents()
                      .filter(Boolean)
                      .map((Component, index) => (
                        <SwiperSlide key={index}>
                          <div
                            className={`slide-content ${index === activeIndex ? 'active' : ''}`}
                            ref={index === activeIndex ? cardRef : null}
                          >
                            {Component}
                          </div>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </Box>
                <Stack
                  sx={{
                    marginTop:
                      symptomCheckerResults?.length > 0 ? '0px' : clientType === CLIENT_TYPES.DEFAULT ? '70px' : '40px',
                  }}
                >
                  {/* Health Category Navigation */}
                  <Box
                    sx={{
                      position: 'relative',
                      bottom: config?.resultPageSlider?.isResultPageSliderVisible ? '80px' : '0px',
                    }}
                  >
                    {config?.resultPageSlider?.isResultPageSliderVisible && (
                      <HealthCategoryNav
                        categories={categories}
                        activeIndex={activeCategoryIndex}
                        onSelectCategory={handleCategorySelect}
                        isLargeScreen={isLargeScreen}
                        clientBaseNavCss={{
                          arrowColor: config?.resultPageSlider?.arrowColor,
                          arrowHOverColor: config?.resultPageSlider?.arrowHOverColor,
                          movingIndicatorColor: config?.resultPageSlider?.movingIndicatorColor,
                          startIconColorActive: config?.resultPageSlider?.startIconColorActive,
                        }}
                      />
                    )}
                  </Box>

                  {/* Centered Controls Container */}
                  <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      width: '100%',
                      position: 'relative',
                      zIndex: 1,
                      bottom:
                        isAtplFlow || isHelloHealthFlow || config?.resultPageSlider?.isResultPageSliderVisible
                          ? '80px'
                          : '44px',
                    }}
                  >
                    {(headerData.name !== 'Overall Health Score' || isAtplFlow || isHelloHealthFlow) && (
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        {isFromDoktor &&
                        !isGameCompleted &&
                        !isClientResultsUrl &&
                        ['Physical Health', 'Overall Disease Risk', 'Metabolic Health'].includes(headerData.name) ? (
                          <Box sx={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                            <ResultsDialog isHandleOverlayVisibilty={isHandleOverlayVisibilty} />
                          </Box>
                        ) : (
                          <>
                            {/* View Analysis Button */}
                            <Box
                              sx={{
                                width: '100%',
                                maxWidth: '400px',
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '14px',
                              }}
                            >
                              {' '}
                              {clientType == CLIENT_TYPES.DEFAULT && blurAndHide ? (
                                <Stack
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    width: '100%',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color: 'rgba(0, 0, 0, 0.69)',
                                      fontSize: '14px',
                                      fontWeight: 600,
                                      lineHeight: '17px',
                                      textAlign: 'center',
                                      padding: '14px 0px',
                                    }}
                                  >
                                    $2.99 per week
                                  </Typography>
                                  <Button
                                    onClick={handleUpgradeToSeeResults}
                                    fullWidth
                                    className="btn-shadow"
                                    sx={{
                                      height: '60px',
                                      color: '#fff',
                                      borderRadius: isFromDoktor || isAtplFlow || isHelloHealthFlow ? '10px' : '40px',
                                      marginBottom: '10px',
                                      background: config.button.background,
                                      textAlign: 'center',
                                      boxShadow:
                                        '0px 12px 30px 6px rgba(0, 0, 0, 0.05), 0px 18px 40px 10px rgba(0, 0, 0, 0.06)',
                                      '&:hover': {
                                        color: 'black',
                                      },
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        width: '100%',
                                        textDecoration: 'none',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        color: 'inherit',
                                        fontSize: '18px',
                                      }}
                                    >
                                      🚀 Upgrade to See Results
                                    </Typography>
                                  </Button>
                                  <Typography
                                    sx={{
                                      color: '#35C6C9',
                                      fontSize: '20px',
                                      fontWeight: 600,
                                      lineHeight: '25px',
                                      textAlign: 'center',
                                      padding: '14px 0px',
                                    }}
                                  >
                                    I’d Rather Invite Friends to View My Results... 👯‍♀️
                                  </Typography>
                                </Stack>
                              ) : (
                                <Button
                                  fullWidth
                                  className="btn-shadow"
                                  onClick={
                                    // Handle lab test external navigation (always last slide in HelloHealth)
                                    isHelloHealthFlow && activeIndex == getcomponents().filter(Boolean).length - 1
                                      ? () =>
                                          window.open(
                                            'https://www.gethellohealth.com/collections/lab-tests-1',
                                            '_blank',
                                          )
                                      : // Handle product page navigation (second to last in HelloHealth, last in others)
                                        (isHelloHealthFlow &&
                                            activeIndex == getcomponents().filter(Boolean).length - 2) ||
                                          (!isHelloHealthFlow &&
                                            (isAtplFlow || clientType == CLIENT_TYPES.DEFAULT) &&
                                            activeIndex == getcomponents().filter(Boolean).length - 1)
                                        ? learMoreResponsivePageBtnHandler
                                        : (isAtplFlow || isHelloHealthFlow) &&
                                            headerData.name === 'Overall Health Score'
                                          ? findProductBtnHandlerForSymptomPage
                                          : undefined
                                  }
                                  sx={{
                                    height: '60px',
                                    color: '#fff',
                                    borderRadius: isFromDoktor || isAtplFlow || isHelloHealthFlow ? '10px' : '40px',
                                    marginBottom: '6px',
                                    background: config.button.background,
                                    textAlign: 'center',
                                    boxShadow:
                                      '0px 12px 30px 6px rgba(0, 0, 0, 0.05), 0px 18px 40px 10px rgba(0, 0, 0, 0.06)',
                                    '&:hover': {
                                      color: 'black',
                                    },
                                  }}
                                >
                                  {headerData.name !== 'Overall Health Score' ? (
                                    // Lab test page (last slide in HelloHealth) - show Typography
                                    isHelloHealthFlow && activeIndex == getcomponents().filter(Boolean).length - 1 ? (
                                      <Typography
                                        sx={{
                                          width: '100%',
                                          textDecoration: 'none',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          color: 'inherit',
                                          fontSize: '18px',
                                          fontWeight: 500,
                                        }}
                                      >
                                        See All Tests
                                      </Typography>
                                    ) : (
                                      // All other cases - use Link
                                      <Link
                                        to="/results/analysis"
                                        state={{item}}
                                        style={{
                                          width: '100%',
                                          textDecoration: 'none',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          color: 'inherit',
                                          fontSize: '18px',
                                        }}
                                      >
                                        {/* Product page button text */}
                                        {(isHelloHealthFlow &&
                                          activeIndex == getcomponents().filter(Boolean).length - 2) ||
                                        (!isHelloHealthFlow &&
                                          (isAtplFlow || clientType == CLIENT_TYPES.DEFAULT) &&
                                          activeIndex == getcomponents().filter(Boolean).length - 1)
                                          ? 'Learn More'
                                          : '👀 Find Products That Can Help'}
                                      </Link>
                                    )
                                  ) : (
                                    <Typography
                                      sx={{
                                        width: '100%',
                                        textDecoration: 'none',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        color: 'inherit',
                                        fontSize: '18px',
                                        fontWeight: 500,
                                      }}
                                    >
                                      {(isHelloHealthFlow &&
                                        activeIndex == getcomponents().filter(Boolean).length - 2) ||
                                      (!isHelloHealthFlow &&
                                        (isAtplFlow || clientType == CLIENT_TYPES.DEFAULT) &&
                                        activeIndex == getcomponents().filter(Boolean).length - 1)
                                        ? 'Learn More'
                                        : '👀 Find Products That Can Help'}
                                    </Typography>
                                  )}
                                </Button>
                              )}
                            </Box>

                            {/* Social Share Buttons */}
                            {clientType == CLIENT_TYPES.DEFAULT && blurAndHide ? (
                              ''
                            ) : (
                              <Box
                                sx={{
                                  width: '100%',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  gap: '10px',
                                }}
                              >
                                <ShareButtons cardRef={cardRef} item={item} socialButtonsCss={config?.socialButtons} />
                              </Box>
                            )}
                          </>
                        )}

                        {/* Disclaimer Text */}
                        {
                          <Box
                            sx={{
                              width: '100%',
                              maxWidth: '800px',
                              display: 'flex',
                              justifyContent: 'center',
                              padding: '20px 20px',
                            }}
                          >
                            <Typography
                              color="black"
                              variant="p"
                              component="p"
                              fontWeight="400"
                              sx={{
                                fontSize: '17px',
                                textAlign: 'center',
                              }}
                            >
                              These numbers are only estimates and are not a substitute for the judgment of a healthcare
                              professional. They are intended to improve awareness and general wellness. Please see our
                              <a href="/" className="custom-link-tag">
                                {' '}
                                How it Works{' '}
                              </a>
                              page.
                            </Typography>
                          </Box>
                        }
                      </Box>
                    )}
                  </Stack>
                </Stack>
              </Stack>
            )}
          </div>
        </div>
      ) : (
        // Small Screen Layout
        <div className="parent-div">
          {isLoading.loadingNuralogix && isLoading.loadingSymptomChecker ? (
            isAtplFlow ? (
              <SimpleLoader loadingText="Loading..." textColor="#F15C30" />
            ) : (
              <AnimationLoadingScreenWithProgressBar
                title="Loading..."
                secondsToLoad={60}
                isAlmostComplete={responseReturned}
              />
            )
          ) : (
            <Stack>
              <Swiper
                ref={swiperRef}
                spaceBetween={false}
                effect={'fade'}
                pagination={config?.swiperConfig?.isSwiperPagination ? {clickable: true} : false}
                navigation={config?.swiperConfig?.isSwiperNavigation ? true : false}
                autoHeight={true}
                modules={[EffectFade, Navigation, Pagination]}
                onSlideChange={handleSlideChange}
                className="mySwiper"
              >
                {getcomponents()
                  .filter(Boolean)
                  .map((Component, index) => (
                    <SwiperSlide key={index}>{Component}</SwiperSlide>
                  ))}
              </Swiper>
            </Stack>
          )}
        </div>
      )}
    </>
  );
};

export default ResultsPage;
